// Coin and money columns render in the partner's language but always with Latin
// digits, so a ledger stays scannable and comparable across locales.
export const groupNumber = (value, languageCode, fractionDigits) =>
  Number(value ?? 0).toLocaleString(
    `${languageCode || "en"}-u-nu-latn`,
    fractionDigits
      ? { minimumFractionDigits: fractionDigits, maximumFractionDigits: fractionDigits }
      : undefined,
  );
